// extracted by mini-css-extract-plugin
export default {"wrapper":"XxJ79Cp","pretargetingBudget":"Or8Jwgn"};